document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.set__media.swiper', {
    slidesPerView: 'auto',
    breakpoints: {
      1024: { enabled: false }
    }
  });

  function activateSizeSpan(sizeVariant) {
    const wrap = sizeVariant.closest('.set__variants-sizes');
    if (!wrap) return;
    const sizesGroups = Array.from(wrap.querySelectorAll('.sizes'));
    const labels = wrap.querySelectorAll('.option_variant');
    const group = sizeVariant.closest('.sizes');
    const index = sizesGroups.indexOf(group);

    const labelTopBarEl = group.classList.contains('top')
      ? document.querySelector('.option_variant__top')
      : group.classList.contains('bottom')
        ? document.querySelector('.option_variant__bottom')
        : labels[index];

    labelTopBarEl.textContent = sizeVariant.textContent.trim();
    labels[index].textContent = sizeVariant.textContent.trim();
    group.querySelectorAll('span.active').forEach(s => {
      s.classList.remove('active', 'tw-text-white', 'tw-bg-[#1E2426]');
      s.classList.add('tw-border', 'tw-border-solid', 'tw-border-[#1e242629]');
    });

    sizeVariant.classList.remove(
      'tw-text-[#1e242666]',
      'tw-bg-[#E9EAEC]',
      'tw-border',
      'tw-border-solid',
      'tw-border-[#1e242629]'
    );
    sizeVariant.classList.add('active', 'tw-text-white', 'tw-bg-[#1E2426]');
  }

  document.addEventListener('click', e => {
    const sizeVariant = e.target.closest('.set__variants-sizes .sizes span');
    if (!sizeVariant || sizeVariant.dataset.available === 'false') return;
    activateSizeSpan(sizeVariant);
  });

  document.addEventListener('size-memory-select', e => {
    const sizeVariant = e.target.closest('.set__variants-sizes .sizes span');
    if (!sizeVariant) return;
    activateSizeSpan(sizeVariant);
  });

  document
    .querySelectorAll('.set__variants-sizes .sizes')
    .forEach(sizesWrap => {
      if (
        sizesWrap.classList.contains('top') &&
        sizesWrap.querySelector('span.active')
      ) {
        document.querySelector('.option_variant__top').textContent = sizesWrap
          .querySelector('span.active')
          .textContent.trim();
      } else if (
        sizesWrap.classList.contains('bottom') &&
        sizesWrap.querySelector('span.active')
      ) {
        document.querySelector('.option_variant__bottom').textContent =
          sizesWrap.querySelector('span.active').textContent.trim();
      }
    });

  const setLoading = (button, on) => {
    if (!button) return;
    button.disabled = !!on;
    button.style.opacity = on ? '0.5' : '';
    button
      .querySelector('.loading-overlay__spinner')
      .classList.toggle('hidden', !on);
  };

  const btn = document.querySelector('.set_btn');

  btn.addEventListener('click', async () => {
    const from = addFromFlag;
    addFromFlag = 'product_main';
    const setId = document.querySelector('.matching-set').dataset.productId;

    const actives = document.querySelectorAll('.sizes .active');
    const ids = [];
    actives.forEach(el => {
      (el.dataset.ids || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .forEach(id => ids.push(id));
    });
    const accessoryEl = document.querySelector('.accessories.option_variant');
    if (accessoryEl) {
      (accessoryEl.dataset.ids || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .forEach(id => ids.push(id));
    }
    const uniqueIDs = ids.filter((v, i, a) => a.indexOf(v) === i).map(Number);
    if (!uniqueIDs.length) return;

    const items = uniqueIDs.map(id => ({
      id,
      quantity: 1
    }));

    try {
      setLoading(btn, true);
      setLoading(document.querySelector('.set_sticky-btn'), true);

      const ok = await addToCart(items, 'matching-sets');

      if (setId) {
        sessionStorage.setItem(
          'set_set_data_info',
          JSON.stringify({
            ids: uniqueIDs.map(String),
            setId
          })
        );
      }

      if (ok) {
        const cart = await fetchCart(ok.sections?.['slide-cart-fragment']);
        document.dispatchEvent(
          new CustomEvent('cart:added', { detail: { source: 'matching-sets' } })
        );

        const bubble = document.querySelector('.cart-count-bubble');
        bubble?.classList.remove('hidden');
        bubble
          ?.querySelector('span')
          ?.replaceChildren(document.createTextNode(cart.item_count));

        const justAdded = new Set(uniqueIDs);
        cart.items.forEach(item => {
          if (!justAdded.has(item.id)) return;

          const unitPriceCents = (item.final_price ?? item.price) || 0;
          const unitPrice = unitPriceCents / 100;

          let handle = '';
          if (item.url) {
            const after = item.url.split('/products/')[1] || '';
            handle = after.split(/[?#]/)[0];
          }

          let setIdForEvent = setId;
          if (!setIdForEvent) {
            const lastSet = JSON.parse(
              sessionStorage.getItem('set_set_data_info') || 'null'
            );
            if (lastSet?.ids?.includes(String(item.id)))
              setIdForEvent = lastSet.setId || '';
          }

          addToCartSetEvent(
            setIdForEvent,
            1,
            from,
            item.id,
            unitPrice,
            handle,
            item.url,
            readPdpEventExtras()
          );
        });
      }
    } catch {
    } finally {
      setLoading(btn, false);
      setLoading(document.querySelector('.set_sticky-btn'), false);
    }
  });

  $('.set__media')
    .find('.product_gallery')
    .fancybox({
      loop: true,
      closeExisting: true,
      thumbs: {
        autoStart: false
      }
    });
});
